if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"loans","remotes":[{"alias":"md","name":"md","entry":"undefined/remoteEntry.js","shareScope":"default","externalType":"script"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1981|5828)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {"md":[{"alias":"md","name":"md","entry":"undefined/remoteEntry.js","shareScope":"default","externalType":"script"}]}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}